export default {"src":"/_next/static/media/nut.67ee29b9.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};